import { useMemo } from 'react';
import { isAnswered, isAnswerEnd, } from '@/utils/modules/rfp/professional/questionAnswerStatus';
import { getIsDisclose, getIsDiscloseApproved, } from '@/utils/modules/viewRequest/disclose';
/**
 * データをコンポーネントに渡す値に変更する
 */
export const useRfpProfessionalQuestionListPage = (args) => {
    const { onlineQuestions, rfp } = args;
    // 開示状態が「公開」か判定
    const isDisclose = getIsDisclose(rfp.is_disclose);
    // 開示済みか判定
    const isDiscloseApproved = getIsDiscloseApproved(rfp.is_disclose_approved);
    // 一覧の表示データ取得
    const questionItems = useMemo(() => onlineQuestions.map((q) => ({
        answer: q.answer,
        id: q.id,
        isAnswered: isAnswered(q.answer_status),
        isEnd: isAnswerEnd(q.answer_status),
        isSelf: q.is_self,
        isUnread: q.is_unread,
        question: q.question,
    })), [onlineQuestions]);
    return {
        isDisclose,
        isDiscloseApproved,
        questionItems,
    };
};
